import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./checkout.css";

function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <div className="checkout-container">
      <Navbar />
      <div className="checkout-message cancel">
        <h1>⚠️ Pago cancelado</h1>
        <p>Tu suscripción no fue procesada. Puedes volver a intentarlo cuando quieras.</p>
        <button onClick={() => navigate("/planes")}>Elegir otro plan</button>
      </div>
    </div>
  );
}

export default CheckoutCancel;
